import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bca_logo_m",
  "use": "bca_logo_m-usage",
  "viewBox": "0 0 76.29 81.86",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 76.29 81.86\" id=\"bca_logo_m\">\n    <path fill=\"currentColor\" d=\"M65.33 0h10.96v81.86H64.51v-63.7L39.35 49.8h-2.17L11.72 18.16v63.69H0V0h11.09l27.2 33.62L65.33 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol